import { all, takeEvery } from 'redux-saga/effects';
import actions from './actions';
import CollectionSagas from '../Collection/sagas';

class Highlights extends CollectionSagas {

    constructor() {
        super(actions,'highlights', ['editions']);
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.LOAD_FROM_FIRESTORE, new Highlights().loadFromFirestore),
        takeEvery(actions.SAVE_INTO_FIRESTORE, new Highlights().storeIntoFirestore),
    ]);
}
